export default "__VITE_ASSET__3489335f__"